export default {
    meter: "Mita",
    kiloMeter: "Kilomita",
    gram: "Gramu",
    kilogram: "Kilogramu",
    pound: "Pauni",
    cubicKilo: "Kilomita za ujazo (km³)",
    cubicMeter: "Mita za ujazo (m³)",
    cubicCentimeter: "Sentimita za ujazo (cm³)",
    cubicMilimeter: "Milimita za ujazo (mm³)",
    used: "Imetumika",
    maxLimit: "Kikomo cha juu hakipaswi kuwa zaidi ya tarakimu sita.",
    emptyDeforestationStatus: "Hali ya uharibifu wa misitu ya EUDR iko tupu.",
    warning: "Onyo",
    psw: "Nenosiri",
    topFive: "5 Bora",
    confPsw: "Thibitisha Nenosiri",
    fermentation: "jäsning",
    newPsw: "Nenosiri Mpya",
    email: "Barua pepe",
    emailId: "Kitambulisho cha barua pepe",
    submit: "Wasilisha",
    cancel: "Ghairi",
    faqs: "Maswali Yanayoulizwa Mara kwa Mara",
    users: "Watumiaji",
    language: "Lugha",
    appUser: "Mtumiaji wa Programu",
    app_users: "Watumiaji wa Programu",
    offline_users: "Watumiaji wa Nje ya Mtandao",
    dimitraAdmin: "Msimamizi wa Dimitra",
    admin_users: "Watumiaji wa Usimamizi",
    search: "Tafuta",
    searchByProducerName: "Tafuta kwa jina la mtayarishaji",
    searchBy: "Tafuta {type}",
    firstName: "Jina la kwanza",
    lastName: "Jina la familia",
    mobile: "Rununu",
    mobileNumber: "Namba ya simu ya mkononi",
    department: "Idara",
    role: "Jukumu",
    status: "Hali",
    permission: "Ruhusa",
    activity_log: "Kumbukumbu ya Shughuli",
    profile_auth: "Uthibitishaji wa Wasifu",
    countryCode: "Msimbo wa Nchi",
    selectDept: "Idara iliyochaguliwa",
    selectRole: "Chagua Jukumu",
    edit: "Hariri",
    update: "Sasisha",
    delete: "Futa",
    view: "Tazama",
    deactivate: "Zima",
    activate: "Amilisha",
    serverError: "Hitilafu fulani imetokea. ",
    minute: "Dakika",
    perHour: "Kwa saa",
    day: "Siku",
    enterDescription: "Weka maelezo yako hapa",
    enterHere: "Ingia Hapa",
    enterMobile: "Weka nambari ya simu",
    phoneRequired: "Simu inahitajika",
    phoneValid: "Simu lazima iwe halali",
    unableToUpdate: "Imeshindwa kusasisha",
    membershipPlans: "Mipango ya Uanachama",
    byWeek: "Kwa Wiki",
    byMonth: "Kwa Mwezi",
    byYear: "Kwa Mwaka",
    custom: "Desturi",
    name: "Jina",
    regionState: "Mkoa/Jimbo",
    provinceState: "Mkoa/Jimbo",
    cityTown: "Kijiji/Mji/Mji",
    membershipValidity: "Uhalali wa Msingi wa Uanachama",
    extendedValidity: "Uhalali Uliopanuliwa",
    exportAsCSV: "Hamisha kama CSV",
    filterBy: "Chuja Kwa",
    autoCondition: "Masharti ya Auto",
    conditional: "Masharti",
    comingSoon: "Inakuja Hivi Karibuni",
    userRole: "Wajibu wa Mtumiaji",
    additionalInformationRequired: "Taarifa ya Ziada Inahitajika",
    back: "Nyuma",
    browse: "Vinjari",
    clearAll: "FUTA YOTE",
    continue: "Endelea",
    resolveNow: "Tatua Sasa",
    description: "Maelezo",
    selectWeek: "Chagua Wiki",
    confirm: "THIBITISHA",
    selectMonth: "Chagua Mwezi",
    selectDateRange: "Chagua Masafa ya Tarehe",
    regionDistrict: "Mkoa/Wilaya",
    address: "Anwani",
    familyTribe: "Kabila la Familia",
    website: "Tovuti",
    deactivated: "Imezimwa",
    active: "Inayotumika",
    inactive: "Isiyotumika",
    country: "Nchi",
    farmer: "Mkulima",
    commodity: "Bidhaa",
    quantity: "Kiasi",
    unit: "Kitengo",
    price: "Bei",
    save: "HIFADHI",
    stateIsReq: "Jimbo linahitajika",
    cityIsReq: "Jiji linahitajika",
    addressIsReq: "Anwani inahitajika",
    membershipTypeReq: "Aina ya uanachama inahitajika",
    extendedReasonReq: "Sababu ya kupanua inahitajika",
    numberOfDaysReq: "Idadi ya siku inahitajika",
    extendedMembershipValidity: "Uhalali wa Uanachama Ulioongezwa",
    set: "WEKA",
    adminRole: "Jukumu la Msimamizi",
    typeMsg: "Andika ujumbe wako hapa",
    mile: "Maili",
    manageFarmer: "Kusimamia Mkulima",
    manageOfflineFarmers: "Dhibiti Wakulima wa Nje ya Mtandao",
    dashboardSettings: "Mpangilio wa Dashibodi",
    done: "Imekamilika",
    noRecordFound: "Hakuna rekodi iliyopatikana",
    farmerName: "Jina la Mkulima",
    production: "Uzalishaji",
    registered: "Imesajiliwa",
    downloadForReport: "PAKUA RIPOTI YA PDF",
    downloadPdfReport: "Pakua Ripoti ya PDF",
    notifications: "Arifa",
    markAllAsRead: "Weka Vyote Kama Vilivyosomwa",
    viewNotifications: "Tazama Arifa",
    youAreUpToDate: "Umesasishwa",
    sendNotifications: "Arifa Zilizotumwa",
    createNotification: "Unda Arifa",
    viewAllNotifications: "Tazama Arifa zote",
    createNotificationForGroup: "Unda Arifa kwa Kikundi/Watumiaji Wengi",
    createNotificationForDimitra: "Unda Arifa kwa Msimamizi wa Dimitra",
    pleaseCheckTickMark:
      "Tafadhali angalia alama ya tiki ili kuongeza mtumiaji kwenye orodha",
    clearAllFilters: "Futa Vichujio Vyote",
    note: "*Kumbuka: Ni faili ya Mp4 pekee ndiyo inayotumika kwa video",
    validMemberships: "Uanachama Halali",
    memberShipPlanMessage:
      "Je, una uhakika unataka kufuta mpango huu wa uanachama?",
    deleteMemberShipPlan: "Futa Mpango wa Uanachama",
    systemAutoLogout: "Mfumo utaondoka kiotomatiki baada ya dakika 2",
    monday: "Jumatatu",
    tuesday: "Jumanne",
    Wednesday: "Jumatano",
    thursday: "Alhamisi",
    friday: "Ijumaa",
    saturday: "Jumamosi",
    sunday: "Jumapili",
    addnewOfflineFarmer: "Ongeza mkulima mpya wa nje ya mtandao",
    export: "Hamisha",
    exportAs: "Chapisha Kama",
    createNewOfflineFarmer: "Unda Mkulima Mpya wa Nje ya Mtandao",
    offlineFarmerForByingStationOnly:
      "Mkulima wa nje ya mtandao kwa kituo cha kununua pekee (Mkoa)",
    offlineFarmerForAllByingStations:
      "Mkulima wa nje ya mtandao kwa vituo vyote vya ununuzi (Global)",
    noDataAvailable: "HAKUNA DATA INAYOPATIKANA",
    buyingStation: "Kituo cha Kununua",
    mergeWithExistingAccount: "Unganisha na akaunti iliyopo",
    createNewAccount: "Fungua akaunti mpya",
    mobileOrEmailRequiredForRegister:
      "Ili kusajili programu, angalau maelezo moja lazima yatolewe ama nambari ya simu au barua pepe.",
    selectLanguage: "Chagua lugha",
    basicPlan: "Mpango wa Msingi",
    local: "Ndani",
    newUser: "Mtumiaji Mpya",
    merged: "Imeunganishwa",
    global: "Ulimwenguni",
    qrcode: "Msimbo wa QR",
    profile: "Profaili",
    pleaseChooseAnImageFile: "Tafadhali chagua faili la picha",
    fileIsTooBigSelectUnder1MB:
      "Faili lako ni kubwa sana! Tafadhali chagua picha chini ya 1MB",
    pleaseTryAgainAfterSometime: "Tafadhali jaribu tena baada ya muda",
    somethingWentWrong: "Kuna kitu kilienda vibaya.",
    passwordChangedSuccesFully: "Nenosiri limebadilishwa kwa mafanikio",
    passwordDoesNotMatch: "Manenosiri hayalingani",
    copyToCliped: "Imenakiliwa kwenye ubao wa kunakili",
    profileUpdated: "Taarifa za profaili zimesasishwa.",
    emailAndMobileCantbeEmpty: "Barua pepe na Simu, zote haziwezi kuwa tupu.",
    changePassword: "Badilisha Nenosiri",
    generateSecurePassword: "Tengeneza Nenosiri Salama",
    restoreDefault: "Rejesha Chaguo-msingi",
    customization: "Ubinafsishaji",
    recordsPerPage: "Rekodi kwa Kila Ukurasa",
    emailSentSuccessfully: "Barua pepe imetumwa kwa mafanikio",
    goBack: "Rudi",
    step: "Hatua",
    fileError: "Kosa la Faili",
    ProvideFileFormat: "Tafadhali toa muundo ufuatao (PNG/JPEG)",
    signHere: "Saini Hapa",
    numOfDaysRemaining: "Idadi ya Siku Zilizosalia",
    requesterNameIsRequired: "Jina la Muombaji linahitajika",
    messageIsRequired: "Ujumbe unahitajika",
    emailIsInvalid: "Barua pepe sio halali",
    emailIsRequired: "Barua pepe inahitajika",
    read: "Imesomwa",
    unread: "Haijasomwa",
    filesSucessfullyUploaded: "Faili zimepakiwa kwa mafanikio",
  
    loadingData: "Inapakia Data...",
    markAsRead: "Weka Alama Kama Imesomwa",
  
    of: "ya",
    ok: "sawa",
  
    orderBy: "Agiza Kwa",
    select: "Chagua",
    type: "Aina",
    uploadImageVideo: "Pakia Picha",
    user: "Mtumiaji",
    userName: "Jina la mtumiaji",
    usersSelected: "Watumiaji Waliochaguliwa",
    topics: "Mada",
    date: "Tarehe",
    addNew: "ONGEZA MPYA",
    exportAsCsv: "Hamisha kama CSV",
    noData: "Hakuna Data Imepatikana",
  
    dashboard: "Dashibodi",
    mainDashboard: "Dashibodi Kuu",
    userDashboard: "Dashibodi ya Mtumiaji",
  
    tickets: {
      actions: {
        create: "Tengeneza Tiketi",
        delete: "Futa Tiketi",
        edit: "Badilisha Tiketi",
      },
      areaOfRequest: "Eneo la Ombi",
      assignee: "Mkabidhiwa",
      deleteTicket: {
        confirmation: "Je, una uhakika unataka kufuta tikiti ya {0}?",
      },
      dueDate: "Tarehe ya kukamilisha",
      filters: {
        ticketFor: "Tiketi Kwa",
      },
      form: {
        ticketType: {
          admin: "Unda Tiketi kwa Msimamizi wa Dimitra",
          user: "Unda Tiketi kwa Mtumiaji wa Programu",
        },
      },
      markAsRead: "Weka alama kama imesomwa",
      messages: {
        created: {
          success: "Tikiti imeundwa",
        },
        deleted: {
          success: "Tikiti imefutwa",
        },
      },
      noData: "Hakuna Tiketi Zilizopatikana!",
      noDataHelpText: "Bado huna tikiti zozote ulizokabidhiwa. ",
      pickerInMenu: "Kiteua kwenye menyu",
      priority: {
        high: "Juu",
        label: "Kipaumbele",
      },
      reply: "Jibu",
      requestedDateTime: "Tarehe na Saa Iliyoombwa",
      requestorDetails: "Maelezo ya Muombaji",
      requestorEmail: "Barua pepe ya Muombaji",
      subject: "somo",
      ticketsForItems: {
        all: "Wote",
        dimitraAdmin: "Msimamizi wa Dimitra",
        multipleUsers: "Watumiaji Nyingi",
        singleUser: "Mtumiaji Mmoja",
      },
      title: "Tiketi",
    },
  
    faqSection: {
      createFaq: "TUNZA MASWALI",
      createTopic: "Tengeneza Mada",
      selectTopic: "Chagua Mada",
      faqQuestion: "Swali la Maswali Yanayoulizwa Mara kwa Mara",
      faqAnswer: "Maswali Yanayoulizwa Mara kwa Mara",
      uploadImgVid: "PakiaTaswira/Video",
      disInFaq: "Onyesha katika sehemu ya Maswali Yanayoulizwa Mara kwa Mara",
      editFaq: "Hariri Maswali Yanayoulizwa Mara kwa Mara",
      topicName: "Jina la Mada",
      parentTopic: "Mada ya Mzazi",
      editTopic: "Hariri Mada",
      createSection: "Tafadhali unda sehemu kwanza",
      createTopicFirst: "Tafadhali tengeneza mada kwanza",
      questionReq: "Swali la Maswali Yanayoulizwa Mara kwa Mara linahitajika",
      answerReq: "Maswali Yanayoulizwa Mara kwa Mara inahitajika",
    },
  
    cropsReport: "Ripoti ya Mazao",
    today: "Leo",
    week: "Wiki",
    month: "Mwezi",
    year: "Mwaka",
    all: "Wote",
    cropsStatistics: "Takwimu za Mazao",
    crops: "Mazao",
    acres: "Ekari",
    totalPlantedArea: "Jumla ya Eneo Lililopandwa",
    farmersChart: "Chati ya Wakulima",
    cropsName: "Jina la mazao",
    farmers: "Wakulima",
    farms: "Mashamba",
    planted: "Imepandwa",
    plantedArea: "Eneo lililopandwa",
    harvested: "Imevunwa",
    yieldAcre: "Mavuno/Ekari",
    selectCrop: "Chagua Mazao",
    listByYield: "Orodha kwa Mazao",
    listByPlantedArea: "Orodha kwa Eneo Lililopandwa",
    equipmentReport: "Ripoti ya Vifaa",
    equipmentChart: "Chati ya Vifaa",
    selectFarmer: "Chagua Mkulima",
    selectFarmers: "Chagua Wakulima",
    equipmentName: "Jina la Kifaa",
    region: "Mkoa",
    counts: "Hesabu",
    large: "Kubwa",
    medium: "Kati",
    small: "Ndogo",
    listByFarmer: "Orodha Na Mkulima",
    rowsPerPage: "Safu kwa kila ukurasa",
    farmersReport: "Ripoti ya Wakulima",
    farmersStatistics: "Takwimu za Wakulima",
    averageFarmerLand: "Wastani wa Ardhi ya Mkulima",
    largeFarmers: "Wakulima Wakubwa",
    mediumFarmers: "Wakulima wa Kati",
    smallFarmers: "Wakulima Wadogo",
    listByLand: "Orodha kwa Ardhi",
    listByFarm: "Orodha kwa Shamba",
    AvgLandAcre: "Wastani wa Ardhi/Ekari",
  
    listbyCrop: "Orodha kwa Mazao",
    listbyZone: "Orodha kwa Eneo",
    farmName: "Jina la Shamba",
    zones: "Kanda",
    area: "Eneo",
    goalsAchievedReport: "Ripoti ya Malengo Yaliyofikiwa",
    listByCrops: "Orodha Kwa Mazao",
    goalsAchievedChart: "Chati ya Malengo Yaliyofikiwa",
    goalsAchieved: "Malengo Yamefikiwa",
    goalsFailed: "Malengo Yameshindikana",
    successRate: "Kiwango cha Mafanikio",
    achieved: "Imefikiwa",
    equipment: "Vifaa",
    pests: "Wadudu",
    regions: "Mikoa",
    filterByCrops: "Chuja Kwa Mazao",
    searchCrops: "Tafuta Mazao",
    batchCode: "Msimbo wa Kundi",
    batchRating: "Ukadiriaji wa Kundi",
    MakeASelection: "Fanya uteuzi",
    typeTotalCoffeeQuantity: "Chapa jumla ya kiasi cha kahawa",
    typeHumidity: "Aina ya unyevu",
    valueInPercent: "thamani katika %",
    purchaseOrderRequired: "Agizo la Ununuzi linahitajika",
    totalCoffeeCherryRequired: "Jumla ya Cherry ya Kahawa inahitajika",
    processTypeRequired: "Aina ya Mchakato inahitajika",
    fermentationTypeRequired: "Aina ya kuchachusha inahitajika.",
    stationInfo: "Taarifa za kituo",
    purchaseOrders: "Maagizo ya Ununuzi",
    processingBatch: "Kundi la usindikaji",
    processedCoffeeOutRequired: "Kahawa Iliyochakatwa inahitajika",
    lotNo: "Mengi No",
    addNewS: "Ongeza Mpya",
    viewAll: "Tazama zote",
    parchmentOut: "Parchment nje",
    processingDone: "Usindikaji Umekamilika",
    farmerLotID: "Mkulima",
    weight: "Uzito",
    plantationSettings: "Mipangilio ya Upandaji miti",
    PlantationsEachFarmerCanCreate:
      "Idadi ya Mashamba ambayo Kila Mkulima Anaweza Kuunda",
    manageAdditionalPlantationRequests:
      "Dhibiti Maombi ya Ziada ya Upandaji miti",
    autoApprove: "Idhinisha Kiotomatiki",
    adminApprovalRequired: "Idhini ya Msimamizi Inahitajika",
    close: "Funga",
    new_user: "Mtumiaji Mpya",
    KGAcre: "KG/Ekari",
    activated: "Imewezeshwa",
    addDepartment: "Ongeza Idara",
    addUserRole: "Ongeza Nafasi ya Mtumiaji",
    Area: "Eneo",
    assigned: "Imepangiwa",
    "Avg. land/Acre": "Wastani. Ardhi/Eka",
    "Avg. Land/Acre": "Wastani. Ardhi/Eka",
    basicPlanValidity: "Uhalali wa Mpango Msingi",
    copy: "Nakili",
    Counts: "Hesabu",
    Crop: "Mazao",
    "Crop Name": "Jina la Zao",
    Crops: "Mazao",
    "Crops Report": "Ripoti ya Mazao",
    cuppingScore: "Alama ya Kikombe",
    deleteTopic: "Futa Mada",
    departmentName: "Jina la Idara",
    dryMillingStation: "Kituo cha Kusaga Kavu",
    editUserRole: "Hariri Nafasi ya Mtumiaji",
    endDateRequired: "Tarehe ya Mwisho Inahitajika",
    endSurvey: "Maliza Utafiti",
    "Equipment Name": "Jina la Vifaa",
    "Equipment Report": "Ripoti ya Vifaa",
    expiry: "Muda wa Mwisho",
  
    months: "Miezi",
    days: "Siku",
    open: "Wazi",
    closed: "Imefungwa",
    moreInfoRequired: "Maelezo Zaidi Yanahitajika",
    publicDueDiligenceReportSettings: "Mipangilio ya Ripoti ya Uangalizi wa Umma",
    fieldRequired: "Sehemu hii inahitajika.",
    valueMustBeGreaterThanZero: "Thamani lazima iwe kubwa kuliko sifuri.",
    valueExceedsLimit:
      "Muda wa kumalizika hauwezi kuzidi miezi 12 kulingana na kanuni za EUDR.",
    valueMustBeInteger: "Thamani lazima iwe nambari kamili.",
    reset: "Weka upya",
    showingAll: "Inaonyesha Yote",
    viewDeforestationDetails: "Onyesha Details ya UKataji Miti",
    listOfShipments: "Orodha ya Usafirishaji",
    viewShipment: "Tazama Usafirishaji",
    shipmentCratedSuccess: "Usafirishaji umeundwa kwa mafanikio.",
    pleaseSelectAtLeastOneDueDeligenceReport:
      "Tafadhali chagua angalau ripoti moja ya bidii ya umma",
    confirmation: "Confirmation",
    "Farm Name": "Jina la Shamba",
    "Farm Size": "Ukubwa wa Shamba",
    Farmer: "Mkulima",
    "Farmer Name": "Jina la Mkulima",
    Farmers: "Wakulima",
    "Farmers Report": "Ripoti ya Wakulima",
    Farms: "Mashamba",
    "Farms Report": "Ripoti ya Mashamba",
    farmsChart: "Chatu ya Mashamba",
    farmsReport: "Ripoti ya Mashamba",
    farmStatistics: "Takwimu za Shamba",
    fermentationCode: "Kodi ya Uchachuaji",
    fullWashed: "Imesafishwa Kabisa",
    "Goals Achieved": "Malengo Yaliyotimizwa",
    "Goals Achieved Report": "Ripoti ya Malengo Yaliyotimizwa",
    "Goals Failed": "Malengo Yaliyoshindwa",
    Harvested: "Vilivyovunwa",
    hideLogo: "Ficha Nembo?",
    hideSplash: "Ficha Splash?",
    honey: "Asali",
    id: "Kitambulisho",
    label: "Lebo",
    "Large Farmer": "Mkulima Mkubwa",
    "Medium Farmer": "Mkulima wa Kati",
    membershipExpiryDate: "Tarehe ya Kuisha kwa Uanachama",
    naturalDry: "Kavu Asilia",
    pending: "Inasubiri",
    "Pest Name": "Jina la Mdudu",
    "Pest Report": "Ripoti ya Wadudu",
    Planted: "Imepandwa",
    "Planted Area": "Eneo Lililopandwa",
    processor: "Prosesa",
    publishSurvey: "Chapisha Utafiti",
  
    Region: "Mkoa",
    "Region Name": "Jina la Mkoa",
    "Regional Report": "Ripoti ya Kikanda",
    remove: "Ondoa",
    SemiWashed: "Nusu-Iliyosafishwa",
    "Small Farmer": "Mkulima Mdogo",
    startDateRequired: "Tarehe ya Kuanza Inahitajika",
    "Success Rate": "Kiwango cha Mafanikio",
    sureToDeleteTopic: "Una uhakika unataka kufuta mada ya masuala ya kiufundi?",
    "Total Area": "Eneo Jumla",
    unassigned: "Haijatengwa",
    unsynced_record: "Rekodi Isiyoratibiwa",
    warehouse: "Ghala",
    wine: "Mvinyo",
    "Yield/acre": "Mavuno/kwa Eka",
    "Yield/area": "Mavuno/kwa Eneo",
    Zones: "Zones",
  
    confirmDialog: {
      assessmentBuilder: {
        delete: {
          title: "Futa Tathmini",
          message: "Una uhakika unataka kufuta Tathmini?",
          confirmBtn: "Thibitisha?",
        },
      },
      dueDiligenceReport: {
        delete: {
          title: "Futa Ripoti ya Uchunguzi wa EUDR",
          message: "Una uhakika unataka kufuta Ripoti ya Uchunguzi wa EUDR?",
          confirmBtn: "Thibitisha",
        },
      },
      farm: {
        delete: {
          title: "Futa Shamba",
          message: "Una uhakika unataka kufuta Shamba?",
          confirmBtn: "Thibitisha",
        },
      },
      status: {
        delete: {
          title: "Futa Hali ya Ukataji Miti",
          message: "Je, uko na uhakika unataka kufuta hali ya ukataji miti?",
          confirmBtn: "Thibitisha",
        },
      },
    },
  
    timeAgo: {
      minute: "dakika moja iliyopita",
      minutes: "dakika {count} zilizopita",
      hour: "saa moja iliyopita",
      hours: "saa {count} zilizopita",
      day: "siku moja iliyopita",
      days: "siku {count} zilizopita",
      month: "mwezi mmoja uliopita",
      months: "miezi {count} iliyopita",
      year: "mwaka mmoja uliopita",
      years: "miaka {count} iliyopita",
    },
    pleaseAgreeToDeclaration: "Tafadhali kubali tamko ili kumaliza.",
    importProductionPlaceTT:
      "Inaruhusu watumiaji kuagiza data za mahali pa uzalishaji kwa kutumia chaguo za kupakia au kupakua faili.",
    defaultCircularGeofence:
      "Mashamba bila geofence au bila taarifa kuhusu ukubwa wao watapewa geofence ya mduara ya 4 hekta. Ikiwa ukubwa wa wastani wa shamba ni chini ya hekta 4, tafadhali badilisha ukubwa wa chaguo-msingi kwa kubofya kitufe cha 'Hariri' hapa chini.",
    accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon:
      "Kulingana na EUDR, mashamba yenye chini ya hekta 4 hayahitaji poligoni.",
    uploadOneDeforestationAssessmentForAllFarms:
      "PAKIA TATHMINI MOJA YA UKATAJI MITI KWA MASHAMBA YOTE",
    uploadAssessment: "Pakia Tathmini",
    noUploadToBlockchain: "Hakuna Upakiaji kwa Blockchain",
    noDataForBlockchain:
      "Kwa kuwa hakuna ripoti za ukataji miti zilizotolewa kwa maeneo ya uzalishaji, hakukuwa na data ya kuandika kwenye blockchain. Ikiwa hili halikutarajiwa, tafadhali hakikisha kuwa ripoti za mashamba zilitolewa ipasavyo katika hatua za awali.",
    seeDetails: "Tazama Maelezo",

    countries: "Mkoa",
    clickHere: "Bofya hapa",
    tutorials: {
      howtoCreateanAdminUser: "Jinsi ya Kuunda Mtumiaji wa Msimamizi",
      howToCreateanActivationKey: "Jinsi ya Kuunda Ufunguo wa Uanzishaji",
      individualandBulkFarmCreation: "Uundaji wa Mashamba Binafsi na kwa Wingi",
      creatingaDueDiligenceStatement: "Kuunda Taarifa ya Uangalizi",
      title: "Mafunzo na Miongozo",
      noTutorials: "Hakuna Mafunzo",
      addTutorialPrompt: "Tafadhali ongeza kwanza mafunzo au mwongozo.",
      videoNotAvailable: "Video haipatikani kwa lugha unayopendelea.",
      watchVideo: "Tazama Video",
      viewTutorial: "Tazama Mafunzo",
      // Kenyan tutorials
      creatingAndManagingUsers: "Kuunda na Kusimamia Watumiaji",
      howToCreateActivationKeys: "Jinsi ya Kuunda Vifunguo vya Uanzishaji",
      userRolesAndPermissions: "Majukumu na Ruhusa za Mtumiaji",
      creatingAFarm: "Kuunda Shamba",
      creatingADueDiligenceStatement: "Kuunda Taarifa ya Uangalizi",
      sharingStatementWithOperator: "Kushiriki Taarifa na Mwendeshaji",
      riskMitigation: "Kupunguza Hatari",
      generalSettings: "Mipangilio ya Jumla",
      assessmentBuilder: "Mjenzi wa Tathmini",
      bulkUserUpload: "Upakiaji wa Watumiaji Kwa Wingi",
      // Admin management
      manageTutorials: "Simamia Mafunzo",
      createTutorial: "Unda Mafunzo",
      editTutorial: "Hariri Mafunzo",
      deleteTutorial: "Futa Mafunzo",
      deleteConfirmation: "Je, una uhakika unataka kufuta mafunzo '{title}'?",
      createSuccess: "Mafunzo yameundwa kwa mafanikio",
      updateSuccess: "Mafunzo yameboreshwa kwa mafanikio",
      deleteSuccess: "Mafunzo yamefutwa kwa mafanikio",
      createError: "Hitilafu wakati wa kuunda mafunzo",
      updateError: "Hitilafu wakati wa kuboresha mafunzo",
      deleteError: "Hitilafu wakati wa kufuta mafunzo",
      saveError: "Hitilafu wakati wa kuhifadhi mafunzo",
      loadError: "Hitilafu wakati wa kupakia mafunzo",
      createFirstTutorial: "Unda mafunzo yako ya kwanza ili uanze",
      // Form fields
      description: "Maelezo",
      url: "URL",
      urlType: "Aina ya Maudhui",
      displayOrder: "Mpangilio wa Onyesho",
      organization: "Shirika",
      organizationHint: "Chagua 'Kimataifa' kwa mafunzo yanayopatikana kwa mashirika yote, au chagua shirika mahususi",
      userType: "Aina ya Mtumiaji",
      userTypeHint: "Chagua aina gani ya watumiaji wanaweza kuona mafunzo haya",
      isActive: "Ni Hai",
      status: "Hali",
      actions: "Vitendo",
      // Status options
      active: "Hai",
      inactive: "Haijaamilishwa",
      global: "Kimataifa",
      // User types
      appUsers: "Watumiaji wa Programu",
      adminUsers: "Watumiaji wa Msimamizi",
      // Validation messages
      titleRequired: "Kichwa ni lazima",
      titleMinLength: "Kichwa lazima kiwe na angalau herufi 3",
      urlRequired: "URL ni lazima kwa viungo vya nje",
      urlInvalid: "Tafadhali ingiza URL halali",
      urlTypeRequired: "Aina ya maudhui ni lazima",
      fileRequired: "Faili ni lazima kwa mafunzo yanayotegemea faili",
      urlOrFileRequired: "URL au faili lazima itolewe",
      // Search functionality
      searchOrganizations: "Tafuta mashirika...",
      noOrganizationsFound: "Hakuna mashirika yamepatikana",
      searchTutorials: "Tafuta mafunzo...",
      selectOrganization: "Chagua shirika...",
      excludeGlobalForOrg: "Futa tutoriai global kwa shirika",
      exclusionUpdateSuccess: "Tutoriai global kwa shirika yamefutwa kwa mafanikio",
      exclusionUpdateError: "Hitilafu wakati wa kufuta tutoriai global kwa shirika",
      exclusionStatusLoadError: "Hitilafu wakati wa kupakia tutoriai global kwa shirika",
    },
    helpDesk: "Dawati la Msaada",
    generateSecretKey: "Jenga Kituo cha Kikombe",
    secretKey: "Kituo cha Kikombe",
    secretKeyCopied: "Kituo cha Kikombe yamekopied kwa clipboard",
    copied: "Kopied",
    copySecretKeyHint: "Klik ikon salin untuk menyalin kituo cha kikombe",

  };